import React from "react";
import Select from "react-select";

// Estilização select pequeno com 26px de altura
export const customStyles = {
  control: (styles, state) => ({
    ...styles,
    borderColor: state.isFocused ? "#0b813c" : "", // Cor do border quando em foco ou não
    boxShadow: state.isFocused ? "0 0 0 1px rgba(11, 129, 60, 1)" : "none",
    "&:hover": {
      boxShadow: "0 0 0 1px rgba(11, 129, 60, 1)",
    }, // Cor do boxShadow (outline)
    outline: "black", // Remover o outline padrão, se necessário
    fontSize: "12px", // Altera o tamanho da fonte
    height: 26,
    minHeight: 26
  }),
  // Estilos placeholder
  placeholder: (styles) => ({
    ...styles,
    color: "black", // Cor do placeholder
  }),
  // Estilos opções
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#0b813c"
      : state.isFocused
      ? "rgba(11, 129, 60, 0.3)"
      : "white", // Cor de fundo das opções
    color: state.isSelected ? "white" : "#000", // Cor do texto das opções
    fontSize: "12px"
  }),
  container: (provided) => ({
    ...provided,
    height: 26,
    minHeight: 26
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "100%"
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 3px'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999 
  }),
};

// Estilização select padrão
export const defaultStyle = {
  control: (styles, state) => ({
    ...styles,
    borderColor: state.isFocused ? "#0b813c" : "", // Cor do border quando em foco ou não
    boxShadow: state.isFocused ? "0 0 0 1px rgba(11, 129, 60, 1)" : "none",
    "&:hover": {
      boxShadow: "0 0 0 1px rgba(11, 129, 60, 1)",
    }, // Cor do boxShadow (outline)
    outline: "black", // Remover o outline padrão, se necessário
  }),
  // Estilos placeholder
  placeholder: (styles) => ({
    ...styles,
    color: "black", // Cor do placeholder
  }),
  // Estilos opções
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#0b813c' : state.isFocused ? 'rgba(11, 129, 60, 0.3)' : 'white', // Cor de fundo das opções
    color: state.isSelected ? 'white' : '#000', // Cor do texto das opções
  })
};


export const SelectSearch = ({
  options,
  field,
  form,
  disabled,
  customFilter,
  style,
  placeholder = "Selecione",
  noOptionsMessage = "Nenhuma opção encontrada", 
  menuPlacement = "bottom"
}) => (
  <Select
    options={options}
    name={field.name}
    value={
      options?.find((option) => option.value === field.value) || null
    }
    onChange={(option) => {
      form.setFieldValue(field.name, option ? option.value : "");
    }}
    onBlur={field.onBlur}
    placeholder={placeholder}
    noOptionsMessage={() => noOptionsMessage}
    styles={style ? style : customStyles}
    filterOption={customFilter}
    isClearable
    isDisabled={disabled}
    menuPlacement={menuPlacement}
    menuPortalTarget={document.body}
  />
);
